import styled from 'styled-components';

export const SearchBox = styled.input.attrs({
  className: 'email-search',
})`
  border: 1px solid #e4e7ec;
  padding: 10px;
  width: 85%;
  paddingtop: 2px;
  font-size: 12px;
  font-family: Poppins;
  color: #98a2b3;
  border-radius: 4px;

  ::placeholder {
    text-align: left;
    color: #afafaf;
    font-size: 10px;
  }
`;


